import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { NotesTable } from '../../components/NotesTable';
import { SelectFieldTeams } from '../../components/SelectFieldTeams';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { generateQueryParams } from '../../utils/queryParams';
import { hasRole } from '../../utils/roles';

export const TopNotes = ({
  title,
  section = null,
  teamId = null,
  userId = null,
  dateTo = null,
  dateFrom = null,
  filterTeams = false,
}) => {
  const [data, setData] = useState();
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('total_visits');
  const [loading, setLoading] = useState(true);
  const [teamSelected, setTeamSelected] = useState(teamId);
  const t = useTranslate();

  useEffect(() => {
    setTeamSelected(teamId);
  }, [teamId]);

  useEffect(() => {
    let isMounted = true;

    const getMetrics = async () => {
      setLoading(true);
      try {
        const params = {
          sortBy: orderBy,
          sortType: order === 'desc' ? 'DESC' : 'ASC',
          team_id: teamSelected,
          date_from: dateFrom,
          date_to: dateTo,
          user_id: userId,
          section: section,
        };
        const query = generateQueryParams(params);
        const res = await httpClient(apiUrl + '/metrics/top-notes?' + query);
        if (res.status && res.status === 200) {
          if (isMounted) {
            setData(res.json ? res.json.data : []);
          }
        } else {
          if (isMounted) {
            setData([]);
          }
        }
      } catch (error) {
        console.error('Failed to fetch metrics:', error);
        if (isMounted) {
          setData([]);
        }
      }
      setLoading(false);
    };
    getMetrics();

    return () => {
      isMounted = false;
    };
  }, [order, orderBy, userId, teamId, dateFrom, dateTo, teamSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  if (data?.length === 0) {
    return null;
  }

  return (
    <NotesTable
      title={title || t('resources.reports.list.title_top_notes')}
      data={data}
      order={order}
      setOrder={setOrder}
      orderBy={orderBy}
      setOrderBy={setOrderBy}
      loading={loading}
      actions={
        hasRole(['admin', 'gerente']) && filterTeams ? (
          <SelectFieldTeams
            teamSelected={teamSelected}
            setTeam={setTeamSelected}
          />
        ) : null
      }
    />
  );
};
